import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import TimezoneActions from '../actions/TimezoneActions';


const TimezoneSource = {

    getTimezones() {

        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.timezones).fetch();
            },

            success: TimezoneActions.getTimezonesSuccess,
            error: CurrentUserActions.pageFault
        }
    },
};

class TimezoneStore {
    constructor() {
        this.timezones = [];
        this.timezonesLoaded = false;
        this.exportAsync(TimezoneSource);
        this.bindActions(TimezoneActions);
    }

    onGetTimezonesSuccess(response) {
        this.setState({timezones: response.timezones, timezonesLoaded: true});
    }
}

export default createStore(TimezoneStore, 'TimezoneStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/TimezoneStore.js
 **/